import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../../../../shared/shared-dependencies.module';
import { BackupModule } from '../backup/backup.module';
import { DiagnosticsModule } from '../extended-parameters/diagnostics.module';

import { SnapshotDialogComponent } from './snapshot-dialog/snapshot-dialog.component';
import { SnapshotVddSelectionComponent } from './snapshot-dialog/snapshot-vdd-selection/snapshot-vdd-selection.component';
import { SnapshotListComponent } from './snapshot-list/snapshot-list.component';
import { SnapshotComponent } from './snapshot.component';

@NgModule({
  imports: [SharedDependenciesModule, BackupModule, DiagnosticsModule],
  exports: [SnapshotComponent],
  declarations: [
    SnapshotComponent,
    SnapshotListComponent,
    SnapshotDialogComponent,
    SnapshotVddSelectionComponent,
  ],
})
export class SnapshotModule {}
